<template>
  <el-container>
    <el-main style="height:100vh;padding:0px">
      <div  class="div-form">
        <el-form :label-position="labelPosition" label-width="80px" :rules="rules" size="mini" ref="formproductsn" :model="formproductsn">
<!--          <el-form-item label="用户id" required  prop="userAccountId">-->
<!--            <el-col :span="10">-->
<!--              <el-input v-model="formproductsn.userAccountId" ></el-input>-->
<!--            </el-col>-->
<!--          </el-form-item>-->
          <el-form-item label="用户名"  prop="account">
            <el-col :span="10">
<!--              <el-option-->
<!--                v-for="item in filteredUsers"-->
<!--                :key="item.account"-->
<!--                :label="item.account"-->
<!--                :value="item.account">-->
<!--              </el-option>-->
              <el-cascader
                style="width:100%"
                v-model="value"
                :options="this.options"
                @change="handleChange">
              </el-cascader>
            </el-col>
          </el-form-item>
          <el-form-item label="遥控器sn码"  prop="sn1">
            <el-col :span="10">
              <el-input v-model="formproductsn.sn1" ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="飞机sn码"  prop="sn2">
            <el-col :span="10">
              <el-input v-model="formproductsn.sn2" ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="负载sn码"  prop="sn3">
            <el-col :span="10">
              <el-input v-model="formproductsn.sn3" ></el-input>
            </el-col>
          </el-form-item>
<!--          <el-form-item label="设备类型代码"  prop="productType">-->
<!--            <el-col :span="10">-->
<!--              <el-input v-model="formproductsn.productType" ></el-input>-->
<!--            </el-col>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="设备类型代码"  prop="productType">-->
<!--            <el-col :span="4">-->
<!--          <el-select v-model="formproductsn.productType"   placeholder="请选择设备类型">-->
<!--             <el-option v-for="item in productTypes"-->
<!--            :key="item.label"-->
<!--            :label="item.label"-->
<!--            :value="item.label">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--            </el-col>-->
<!--          </el-form-item>-->
          <el-form-item label="有效时间"  prop="deadLineDate">
            <el-col :span="10">
              <el-date-picker type="date" placeholder="选择日期" v-model="formproductsn.deadLineDate" style="width: 100%;" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
          </el-form-item>
          <el-form-item label="产品"  prop="productId">
            <el-col :span="10">
              <el-input  :disabled="true" placeholder="水枪"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="设备权限"  prop="devicePerm">-->
            <el-col :span="10">
              <el-select v-model="formproductsn.devicePerm" @change="$forceUpdate()" style="width:100%"  placeholder="设备权限">
                <el-option v-for="item in devicePerms"
                           :key="item.value"
                           :label="item.label"
                           :value="item.label">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-col :span="10">
              <el-button type="primary" @click="save" >保存</el-button>
              <el-button plain @click="reset">重置</el-button>
              <el-button plain @click="closed">返回</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import router from '../../../router'
import axios from '../../../utils/request'
export default {
  data () {
    return {
      formproductsn: {
        account: '',
        sn1: '',
        sn2: '',
        sn3: '',
        productType: '',
        deadLineDate: '',
        productId: 1,
        userAccountId: '',
        userId: 1,
        companyname: ''
      },
      // productTypes: [{value: 1, label: '无人机'}, {value: 2, label: '遥控器'}, {value: 3, label: '水枪'}],
      filteredUsers: [{}],
      select_product_type: 0,
      rules: {
        account: [
          { required: true, message: '账户名称', trigger: 'change' }
        ],
        sn1: [
          { required: true, message: '请填sn1', trigger: 'change' }
        ],
        sn2: [
          { required: true, message: '请填sn2', trigger: 'change' }
        ],
        deadLineDate: [
          { required: true, message: '请填截止时间', trigger: 'change' }
        ],
        productId: [
          { required: true, message: '请填产品', trigger: 'change' }
        ]
        // ,
        // devicePerm: [
        //   { required: true, message: '请选权限', trigger: 'change' }
        // ]

      },
      options: [],
      value: [],
      devicePerms: [ {value: '0', label: '超级管理员权限'}, {value: '1', label: '普通管理员权限'}, {value: '2', label: '受限权限'} ]
    }
  },
  mounted () {
    this.loading()
  },
  methods: {
    handleChange (val) {
      console.log('级联菜单', val[1])
      this.formproductsn.companyname = val[0]
      this.formproductsn.account = val[1]
    },
    changeaccount: function (e) {
      console.log('account', e)
    },
    save: function () {
      console.log(this.filteredUsers)
      for (let user of this.filteredUsers) {
        console.log(user)
        if (user.account === this.formproductsn.account && user.companyname === this.formproductsn.companyname) {
          this.formproductsn.userAccountId = user.id
        }
      }
      let params = this.formproductsn
      this.$refs.formproductsn.validate((valid) => {
        if (valid) {
          if (params.requesttype === 'update') {
            // this.$delete(params, 'requesttype')
            console.log(params)
            axios.put('/data/bindsn/update', params).then(res => {
              console.log('success')
              this.closed()
            })
          } else {
            axios.post('/data/bindsn/add', params).then(res => {
              console.log('success')
              this.closed()
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    reset: function () {
      this.formproductsn.account = ''
      this.formproductsn.sn1 = ''
      this.formproductsn.sn2 = ''
      this.formproductsn.sn3 = ''
      // this.formproductsn.productType = ''
      this.formproductsn.deadLineDate = ''
      // this.formproductsn.productId = ''
      this.formproductsn.devicePerm = ''
      this.value = []
    },
    closed: function () {
      router.push('/data/gunproductsnbind')
    },
    loading: function () {
      this.formproductsn.userAccountId = this.$route.query.userAccountId === null ? '' : this.$route.query.userAccountId
      this.formproductsn.sn1 = this.$route.query.sn1
      this.formproductsn.sn2 = this.$route.query.sn2
      this.formproductsn.sn3 = this.$route.query.sn3
      this.formproductsn.productType = this.$route.query.productType
      this.formproductsn.deadLineDate = this.$route.query.deadLineDate
      this.formproductsn.productId = 1
      this.formproductsn.id = this.$route.query.id
      this.formproductsn.requesttype = this.$route.query.requesttype
      this.formproductsn.account = this.$route.query.account
      this.formproductsn.companyname = this.$route.query.companyname
      this.select_product_type = this.$route.query.select_product_type
      this.formproductsn.devicePerm = this.$route.query.devicePerm
      this.value[0] = this.$route.query.companyname
      this.value[1] = this.$route.query.account
      axios.get(`/data/account/getAccount?accounttype=1`).then(res => {
        const result = JSON.stringify(res.data)
        this.options = JSON.parse(result)
      })
      this.methodToTrigger()
    },
    methodToTrigger: function () {
      axios.get(`/data/account/am?companyname=&pageNum=&pageSize=`).then(res => {
        this.filteredUsers = res.list
        this.total = res.total
      }).catch(error => {
        console.log('error', error)
      })
    }

  }
}
</script>

<style scoped>
  .el-container {
    height: 100%;
  }
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  .div-form{
    margin-top: 100px;
    margin-left: 280px;
  }
</style>



// WEBPACK FOOTER //
// src/components/table/gun/addgunproductsn.vue